// src/router.tsx
import { createSlice, dynamicPage } from "@loopbound-ares/microfrontend";
import { jsx } from "react/jsx-runtime";
var AccountEmailsPage = dynamicPage(
  () => import("./emails-B6UYPDJN.mjs").then((m) => m.AccountEmailsPage)
);
var AccountHomePage = dynamicPage(() => import("./home-VYERKRY7.mjs").then((m) => m.AccountHomePage));
var AccountOrganizationsPage = dynamicPage(
  () => import("./organizations-VWHQDXIN.mjs").then((m) => m.AccountOrganizationsPage)
);
var AccountProfilePage = dynamicPage(
  () => import("./profile-UA4FARHS.mjs").then((m) => m.AccountProfilePage)
);
var AccountSecurityPage = dynamicPage(
  () => import("./security-2W37GL4B.mjs").then((m) => m.AccountSecurityPage)
);
var AccountLayout = dynamicPage(() => import("./layout-ZEMNISX6.mjs").then((m) => m.AccountLayout));
var accountSlice = createSlice([
  {
    path: "",
    element: /* @__PURE__ */ jsx(AccountLayout, {}),
    children: [
      {
        path: "",
        element: /* @__PURE__ */ jsx(AccountHomePage, {})
      },
      {
        path: "profile",
        element: /* @__PURE__ */ jsx(AccountProfilePage, {})
      },
      {
        path: "security",
        element: /* @__PURE__ */ jsx(AccountSecurityPage, {})
      },
      {
        path: "emails",
        element: /* @__PURE__ */ jsx(AccountEmailsPage, {})
      },
      {
        path: "organizations",
        element: /* @__PURE__ */ jsx(AccountOrganizationsPage, {})
      }
    ]
  }
]);
export {
  accountSlice
};
//# sourceMappingURL=index.mjs.map